import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import PasskeyBanner from "./components/PasskeyBanner";
import BurnRatePage from "./pages/BurnRatePage";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import SteuernPage from "./pages/SteuernPage";
import TotpPage from "./pages/TotpPage";

// T2.14a: EntityDetailPage lazy-geladen (recharts + 4 Sub-Cards
// addieren ~30kB zum App-Shell). Suspense-Fallback haelt Layout stabil.
const EntityDetailPage = lazy(() => import("./pages/EntityDetailPage"));
// T2.16f: DecisionQueuePage lazy
const DecisionQueuePage = lazy(() => import("./pages/DecisionQueuePage"));
// Sprint 4 Push 1: AdminRecurringPage lazy
const AdminRecurringPage = lazy(() => import("./pages/AdminRecurringPage"));
// Sprint 6 Foundation: Bento-Demo lazy (Demo-only, kein Production-Pfad)
const BentoDemoPage = lazy(() => import("./components/bento/__bento_demo"));
// Instrumente-Demo (auth-frei, Beispieldaten) — visuelle Abnahme ohne Login.
const InstrumenteDemoPage = lazy(() => import("./components/__instrumente_demo"));
// Sprint 7 Push 7: Tooltime-Snapshot-Upload (Failsafe gegen Cowork-Sandbox).
const TooltimeUploadPage = lazy(() => import("./pages/TooltimeUploadPage"));
// AUFTRAG F: manuelle Salden-Bruecke bis EBICS-Freischaltung.
const CashEntryPage = lazy(() => import("./pages/CashEntryPage"));
// InfraX-Liquiditaetsplanung (R1-getrennte Sicht, eigener Datenraum).
const InfraxLiquiPage = lazy(() => import("./pages/InfraxLiquiPage"));
// Server-Autonomie: Zugangsdaten pflegen + Tooltime-Profile seeden (kein SSH).
const ZugangsdatenPage = lazy(() => import("./pages/ZugangsdatenPage"));

function PageSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">
      Lade …
    </div>
  );
}

export default function App() {
  return (
    <>
      {/* AUFTRAG E: global, rendert nur mit voller Session + ohne Passkey. */}
      <PasskeyBanner />
      <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/totp" element={<TotpPage />} />
      <Route path="/steuern" element={<SteuernPage />} />
      <Route path="/burn-rate" element={<BurnRatePage />} />
      <Route
        path="/firmen/:firmaId"
        element={
          <Suspense fallback={<PageSpinner />}>
            <EntityDetailPage />
          </Suspense>
        }
      />
      <Route
        path="/cockpit/infrax"
        element={
          <Suspense fallback={<PageSpinner />}>
            <InfraxLiquiPage />
          </Suspense>
        }
      />
      <Route
        path="/decisions"
        element={
          <Suspense fallback={<PageSpinner />}>
            <DecisionQueuePage />
          </Suspense>
        }
      />
      <Route
        path="/admin/recurring"
        element={
          <Suspense fallback={<PageSpinner />}>
            <AdminRecurringPage />
          </Suspense>
        }
      />
      <Route
        path="/admin/bento-demo"
        element={
          <Suspense fallback={<PageSpinner />}>
            <BentoDemoPage />
          </Suspense>
        }
      />
      <Route
        path="/admin/instrumente-demo"
        element={
          <Suspense fallback={<PageSpinner />}>
            <InstrumenteDemoPage />
          </Suspense>
        }
      />
      <Route
        path="/admin/tooltime-upload"
        element={
          <Suspense fallback={<PageSpinner />}>
            <TooltimeUploadPage />
          </Suspense>
        }
      />
      <Route
        path="/admin/cash-eintrag"
        element={
          <Suspense fallback={<PageSpinner />}>
            <CashEntryPage />
          </Suspense>
        }
      />
      <Route
        path="/admin/zugangsdaten"
        element={
          <Suspense fallback={<PageSpinner />}>
            <ZugangsdatenPage />
          </Suspense>
        }
      />
      <Route path="/" element={<DashboardPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
